var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAttachFile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.1 0H8.9C4 0 0 4 0 8.9V31.1C0 36 4 40 8.9 40H31.1C33.9 40 36.4 38.7 38 36.7C39.2 35.2 40 33.2 40 31.1V8.9C40 4 36 0 31.1 0ZM4.4 8.9C4.4 6.4 6.4 4.4 8.9 4.4H31.1C33.6 4.4 35.6 6.4 35.6 8.9V18.4L31.6 14.4C31 13.8 30.1 13.4 29.2 13.4C28.3 13.4 27.5 13.7 26.8 14.4L6.3 34.8C5.1 34 4.4 32.6 4.4 31.1V8.9Z",
    fill: "#7F7F7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAttachFile);
export default __webpack_public_path__ + "static/media/icon-attach-file.a91e2969d74f0706d6ba4a5f1436e1ab.svg";
export { ForwardRef as ReactComponent };